import {useEffect, useState} from "react";
import {getMollieSettlement} from "../api/eventGroupApiClient";

export const useMollieSettlement = (settlementId) => {
    const [settlement, setSettlement] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const abortController = new AbortController();

        getMollieSettlement(settlementId, abortController.signal)
            .then((data) => {
                setSettlement(data);
                setError(null);
            })
            .catch((error) => {
                if (abortController.signal.aborted) {
                    return;
                }

                console.log(error);
                setError(error);
            });

        return () => {
            abortController.abort();
        };
    }, [settlementId]);

    return {settlement : settlement, error};
};
